import {
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnInit,
    Renderer2,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import _ from 'lodash';

@Component({
    selector: 'fe-placeholder, [fe-placeholder]',
    templateUrl: './placeholder.component.html',
    styleUrls: ['./placeholder.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PlaceholderComponent implements OnInit, OnChanges {
    @Input() showPlaceholder = true;

    @Input() placeholderType: 'wave' | 'glow' = 'wave';

    @Input() content = 'content';

    private placeholderClass = 'placeholder';
    private placeholderWaveClass = 'placeholder-wave';
    private placeholderGlowClass = 'placeholder-glow';

    private allClass: string[] = [];

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {}

    public ngOnInit(): void {
        this.buildAllClass({ placeholderType: this.placeholderType });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.buildAllClass(changes);
        this.checkStatus(changes);
    }

    private buildAllClass(changes: SimpleChanges | unknown): void {
        const type = _.get(changes, 'placeholderType.currentValue', 'wave');
        this.allClass = [this.placeholderClass];
        if (type === 'wave') {
            this.allClass.push(this.placeholderWaveClass);
        } else {
            this.allClass.push(this.placeholderGlowClass);
        }
    }

    private checkStatus(changes: SimpleChanges): void {
        const show = _.get(changes, 'showPlaceholder.currentValue', false);
        if (show) {
            _.forEach(this.allClass, (item: string) => {
                this.renderer.addClass(this.elementRef.nativeElement, item);
            });
            return;
        }
        _.forEach(this.allClass, (item: string) => {
            this.renderer.removeClass(this.elementRef.nativeElement, item);
        });
    }
}
